
import apiClient, { apiSendFileHeader, downloadFile, loadFileAsBlob } from "../../../../../../services/apiClient";


export const listDocsKG = async ({kgId, type, no_type, status}) => {

     let url = `kg_docfile_info?kg_id=${kgId}`;

     if(type) url += `&type=${type}`;
     if(no_type) url += `&no_type=${no_type}`;
     if(status) url += `&status=${status}`;

     const response = await apiClient.get(url);
    return response;
};

export const createNewDoc_KG = async (docData) => {

    const url = `kg_docinfo`;

    const response = await apiClient.post(url, docData);

    return response;
};

export const removeDoc_KG = async (docId) => {

     const url = `kg_docinfo?id=${docId}`;

    const response = await apiClient.delete(url);
      return response;
};

export const restoreDoc_KG = async (docId) => {

     const url = `kg_docinfo_restore?id=${docId}`;

    const response = await apiClient.post(url,{});
      return response;
};



export const uploadFile = async (fileInfo, fileBuffer) => {

    const url = `docfile`;

    const response = await apiSendFileHeader(url, fileBuffer, fileInfo);

  return response;
};

export const setFilePublic = async (docId, fileId, isPublic) => {

    const url = `file_set_public?doc_id=${docId}&file_id=${fileId}&value=${isPublic}`;

  const response = await apiClient.put(url);
  return response;
};

export const fileToTrash = async (docId, fileId) => {

    const url = `file_to_trash`;

  const response = await apiClient.post(url, { id_doc: docId, id_file: fileId });
  return response;
};

export const fileRestoreTrash = async (docId, fileId) => {
    const url = `file_restore_trash`;

  const response = await apiClient.post(url,{ id_doc: docId, id_file: fileId });
  return response;
};

export const fileRemove = async (docId, fileId) => {
  const url = `file_remove`
  const response = await apiClient.post(url,{ id_doc: docId, id_file: fileId });
  return response;
};

export const clearTrash = async (docId) => {

    const url = `clear_trash`;

  const response = await apiClient.post(url,{ id_doc: docId });
  return response;
};

export const renameFile = async (docId, fileId, newName) => {
    const url = `rename_file`;

  const response = await apiClient.post(url,{ id_doc: docId, id_file: fileId, name_file: newName });
  return response;
};

export const getFile = async (docId, fileId, fileName) => {

    const url = `docfile?doc_id=${docId}&file_id=${fileId}`;

    const response = await downloadFile(url, fileName);

    return response;
};

export const updateDocInfo = async (id, name, text) => {

  const url = `content/doc_info`;

  const response = await apiClient.put(url,{id,name,text});
  return response;
};

export const getDocInfo = async (id_doc) => {
  const url = `content/doc_info_id?id_doc=${id_doc}`;
  const response = await apiClient.get(url);
  return response;
};

export const getDictionary = async () => {
    const url = `references/document-types?status=active`

    const response = await apiClient.get(url);

    return response.data?.data || []
}

export const getFileBlob = async (docId, fileId) => {
  const url = `docfile?doc_id=${docId}&file_id=${fileId}`;
  
  const response = await loadFileAsBlob(url);
  
  return response;
};
